import { lazy } from "react";

const Login = lazy(() => import("@pages/login"));
const ResetPwd = lazy(() => import("@pages/resetPassword"));
const SafeWarning = lazy(() => import("@pages/safeWarning"));
const NotFound = lazy(() => import("@pages/404/NotFound"));
const homeRoute = [
  {
    path: "/login",
    name: "登录页",
    component: Login,
  },
  {
    path: "/resetPassword",
    name: "重置密码",
    component: ResetPwd,
  },
  {
    path: "/safeWarning",
    name: "安全提示",
    component: SafeWarning,
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
  },
];
export default homeRoute;
